export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9276.07b06d9a.jpg";